// CYBORG-1198: the liveness poll's cheap answer. `lastSeenAt` (the daemon's persisted
// heartbeat) is the one daemon field learned only by polling, so a poll tick asks the
// relay for id/status/lastSeenAt alone and lays them over the full rows it already
// holds. Any change to the SET of daemons (one added, one removed) cannot be answered
// that way: the caller then re-reads the full rows.

export interface DaemonLivenessRow {
  id: string;
  status: string;
  lastSeenAt: number | null;
  /** The relay hides this computer's name and owner from the viewer now. */
  masked?: true;
}

// The held rows with the fresh status + heartbeat, or null when the relay lists a
// different set of daemons than the one held, or one is masked now and not then (sight of it was
// lost or gained): the caller must fetch full rows.
export function mergeDaemonLiveness<T extends DaemonLivenessRow>(
  held: readonly T[],
  liveness: readonly DaemonLivenessRow[],
): T[] | null {
  if (held.length !== liveness.length) return null;
  const fresh = new Map(liveness.map((row) => [row.id, row]));
  if (fresh.size !== liveness.length) return null;
  const merged: T[] = [];
  for (const row of held) {
    const live = fresh.get(row.id);
    if (!live || (live.masked === true) !== (row.masked === true)) return null;
    merged.push({ ...row, status: live.status, lastSeenAt: live.lastSeenAt });
  }
  return merged;
}
